import { BaseController } from '../../../../../../../common/base/controller';
import { MODEL_FIELDS } from '../../confirmWarrant.model';

const ADDITIONAL_ACCOUNT_OWNERS_FIELD = MODEL_FIELDS.additionalAccountOwners;

export class PersonController extends BaseController {
  constructor($scope, $compile, controllerService) {
    'ngInject';
    super({
      $scope,
      $compile,
      controllerService,
    });
  }

  getLabelFor(field) {
    return `${this.translatePrefix}.${field}`;
  }

  get newBankIsForeign() {
    const newIban = this.model[MODEL_FIELDS.newIban];
    return newIban && !newIban.startsWith('DE');
  }

  addAdditionalAccountOwners() {
    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    if (this.model[field].length >= 3) {
      return;
    }
    this.model[field].push({
      [MODEL_FIELDS.firstName]: '',
      [MODEL_FIELDS.lastName]: '',
    });
  }

  removeAdditionalAccountOwner(index) {
    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    this.model[field].splice(index, 1);
  }

  inputMessagesFor(field) {
    return {
      required: `transferring.confirmWarrant.form.error.required.${field}`,
      iban: `transferring.confirmWarrant.form.error.iban.${field}`,
      type: `transferring.confirmWarrant.form.error.type.${field}`,
    };
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;

    this.ibanInputOptions = { type: 'text', validate: 'iban' };
    this.faxNumberOptions = {
      type: 'text',
      pattern: '((0049[0-9])|(0[1-9]{1}))([0-9]{2,20})',
    };
    this.oldIbanMessages = this.inputMessagesFor(this.MODEL_FIELDS.oldIban);
    this.newIbanMessages = this.inputMessagesFor(this.MODEL_FIELDS.newIban);

    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    if (!this.model[field]) {
      this.model[field] = [];
    }

    this.$scope.$watch('vm.newBankIsForeign', (isForeign) => {
      // important: flag must be set to send letter to its dispatched address
      this.model[MODEL_FIELDS.dispatchAddress] = isForeign;
    });
  }
}
